import { put, call, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import FinancialStatementFactory from "../../Entity/Factories/FinancialStatementFactory";
import { FinancialStatementInterface } from "Casadesk/Entity/Entities/FinancialStatement/FinancialStatementInterface";
import Translator from "../../Translation/Translator";

export default function* statementSnooze(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_STATEMENT_SNOOZE_UPDATE_REQUEST
    })

    let requestPayload: any = {};
    if (action.payload) {
      requestPayload.snoozeDate = action.payload?.snoozeDate;
    }

    const res = yield call(Http.put, `financial-statements/${action.payload?.statementId}/snooze`, {...requestPayload});
    const statement: FinancialStatementInterface = FinancialStatementFactory.create(res.data.data);
    
    yield put({
      type: Constants.GLOBAL_FINANCIAL_STATEMENTS_LIST_OUTDATE_REQUESTS
    });

    yield put({
      type: Constants.GLOBAL_STATEMENT_SNOOZE_UPDATE_SUCCESS,
      payload: {
        statement: statement
      }
    });
        
    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: statement?.isSnoozed ? Translator.trans("snackbar-message-statement-snooze-updated-successfully") : Translator.trans("snackbar-message-statement-unsnooze-updated-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res.data.data);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_STATEMENT_SNOOZE_UPDATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchStatementSnooze() {
  yield takeEvery(Constants.GLOBAL_STATEMENT_SNOOZE_UPDATE_START, statementSnooze);
}
